import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const FAQ = (param)=>{
    let { className } = param;
    const t = useTranslations("");
    const faqList = new Array(5).fill("").map((item, index)=>{
        return {
            questions: t("swap_questions" + index),
            answer: t("swap_answer" + index)
        };
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-[var(--text-1)] text-[14px] pb-22px font-bold",
                children: t("swap_faq_title")
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "text-[15px]",
                children: faqList.map((faq, index)=>{
                    return /*#__PURE__*/ _jsxs("li", {
                        className: "[&:not(:last-child)]:mb-16px",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-[var(--text-1)] mb-4px font-medium",
                                children: faq.questions
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-[var(--text-2)]",
                                children: faq.answer
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
export default FAQ;
